import script from "./BaseBreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBreadCrumb.vue?vue&type=script&setup=true&lang=js"

import "./BaseBreadCrumb.vue?vue&type=style&index=0&id=4bd761ae&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd761ae"]])

export default __exports__